module.exports = __webpack_public_path__ + "fonts/Lato-Bold.0f37fb6a.eot";